<div class="rb-rule-row">
  @for (f of field.fieldGroup; track f) {
    <div class="rb-col">
      <formly-field [field]="f"></formly-field>
    </div>
  }
</div>
